import { RootState } from '../../reducers'
import { isTelephonySelector } from '../../store/flow/selectors/selectors'
import { featureValueSelector } from '../../store/features/selectors'

export function isSsmlValidationEnabledSelector(state: RootState) {
  const isTelephony = isTelephonySelector(state)
  const isFeatureEnabled = featureValueSelector('SSML_VALIDATION')(state)

  return isTelephony && !!isFeatureEnabled
}
